document.addEventListener('DOMContentLoaded', function() {

  // ── DATI FRAGRANZE ──
  // Struttura: [nome, url, ufi3, ufi6, ufi8, ufi10]
  // true  = UFI obbligatorio
  // false = UFI non richiesto
  // null  = in aggiornamento (—)
  const fragranze = [
    ["Amber & Woods", "/products/amber-woods", false, false, false, false],
    ["Apple & Cinnamon (Mela & Cannella)", "/products/apple-cinnamon", true, true, true, true],
    ["Baby Powder", "/products/baby-powder", false, false, false, false],
    ["Bergamot (Bergamotto)", "/products/bergamot", false, false, false, true],
    ["Bosco Incantato", "/products/bosco-incantato", false, false, false, false],
    ["Christmas Punch", "/products/christmas-punch", true, true, true, true],
    ["Cipresso Wellness", "/products/cipresso-wellness", false, false, false, false],
    ["Clean Cotton", "/products/clean-cotton", false, false, false, true],
    ["Rose Delicate", "/products/rose-delicate", false, false, false, false],
    ["Divine Red", "/products/divine-red", false, false, false, false],
    ["Egyptian Amber", "/products/fragranza-per-candele-egyptian-amber-per-soia-e-paraffina", false, false, false, false],
    ["Fairy Cake", "/products/fairy-cake", true, true, true, true],
    ["Fig & Blueberry (Fico & Mirtillo)", "/products/fig-blueberry", false, false, false, false],
    ["Forest After The Rain", "/products/forest-after-the-rain", false, false, true, true],
    ["Fragola e Panna", "/products/fragola-e-panna", false, false, false, false],
    ["Gingerbread (Pan di Zenzero)", "/products/gingerbread", true, true, true, true],
    ["Gipsy Chipre", "/products/fragranza-per-candele-gipsy-chipre-per-soia-e-paraffina", false, true, true, true],
    ["Glacial Mint & Vanilla Sugar", "/products/glacial-mint-vanilla-sugar", true, true, true, true],
    ["Golden & Woods", "/products/golden-woods", true, true, true, true],
    ["Hot Chocolate (Cioccolata Calda)", "/products/hot-chocolate", false, false, false, false],
    ["Kumquat & Pompelmo Rosa", "/products/kumquat-pink-grapefruit", false, false, true, true],
    ["Lemon Buds", "/products/lemon-buds", false, false, false, false],
    ["Verbena (Erba Cedrina)", "/products/lemon-verbena", true, true, true, true],
    ["Luxor", "/products/luxor", true, true, true, true],
    ["Mandarin & Cinnamon (Mandarino & Cannella)", "/products/mandarin-cinnamon", true, true, true, true],
    ["Orange & Cinnamon (Arancia & Cannella)", "/products/orange-cinnamon", true, true, true, true],
    ["Orange, Chocolate & Rum", "/products/orange-chocolate-rum", false, false, false, false],
    ["Oriental Vibes", "/products/oriental-vibes", false, false, false, false],
    ["Pandoro", "/products/pandoro", false, false, false, false],
    ["Panettone", "/products/panettone", false, true, true, true],
    ["Peach Bellini", "/products/peach-pesca", false, false, true, true],
    ["Pino Mugo", "/products/pino-mugo", false, false, false, true],
    ["Pompelmo & Calicanto", "/products/diessenza-pompelmo-calicanto", false, false, false, false],
    ["Sea Salt", "/products/sea-salt", false, false, false, false],
    ["Salted Caramel (Caramello Salato)", "/products/salted-caramel", false, false, false, false],
    ["Tobacco & Vanilla (Tabacco & Vaniglia)", "/products/tobacco-vanilla-tabacco-vaniglia", false, true, true, true],
    ["Velvet Fruit", "/products/fragranza-per-candele-velvet-fruit-per-soia-e-paraffina", true, true, true, true],
    ["Vanilla Noir", "/products/vanilla-noir", false, false, true, true],
    ["Very Vanilla", "/products/very-vanilla", false, false, false, false],
    ["Verbena", "/products/lemon-verbena", true, true, true, true],
    ["White Musk", "/products/white-musk", true, true, true, true],
    ["Ylang & Tuberose (Ylang & Tuberosa)", "/products/ylang-tuberose", false, false, false, true],
    ["Zagara e Gelsomino", "/products/zagara-e-gelsomino", false, false, false, false],

  ];

  function ufiCell(val) {
    if (val === null) return '<td class="ufi-cell"><span class="fufi-badge fufi-badge-pending">&#8212;</span></td>';
    return val
      ? '<td class="ufi-cell"><span class="fufi-badge fufi-badge-ufi">&#9888; UFI</span></td>'
      : '<td class="ufi-cell"><span class="fufi-badge fufi-badge-ok">&#10003; UFI Free</span></td>';
  }

  function buildTable() {
    var tbody = document.getElementById('fufi-table-body');
    if (!tbody) return;
    tbody.innerHTML = fragranze.map(function(f) {
      return '<tr data-name="' + f[0].toLowerCase() + '">' +
        '<td class="fragrance-name"><a href="' + f[1] + '">' + f[0] + '</a></td>' +
        ufiCell(f[2]) + ufiCell(f[3]) + ufiCell(f[4]) + ufiCell(f[5]) +
        '</tr>';
    }).join('');
    updateCount(fragranze.length);
  }

  function updateCount(n) {
    var label = document.getElementById('fufi-count-label');
    if (label) label.textContent = n + ' fragranz' + (n === 1 ? 'a' : 'e');
  }

  function applySearch() {
    var q = document.getElementById('fufi-search-input').value.toLowerCase();
    var rows = document.querySelectorAll('#fufi-table-body tr');
    var visible = 0;
    rows.forEach(function(row) {
      if (row.dataset.name.includes(q)) {
        row.classList.remove('hidden-row');
        visible++;
      } else {
        row.classList.add('hidden-row');
      }
    });
    updateCount(visible);
  }

  buildTable();

  var searchInput = document.getElementById('fufi-search-input');
  if (searchInput) searchInput.addEventListener('input', applySearch);

});